import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDrGlxBwnALxXDAcwcCgz52pvC-7d-vWFE",
  authDomain: "tmd-db.firebaseapp.com",
  projectId: "tmd-db",
  storageBucket: "tmd-db.firebasestorage.app",
  messagingSenderId: "798245380304",
  appId: "1:798245380304:web:0057fb43494018079dbed5"
};

const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);

export const db = getFirestore(app);

export default app; 